export const WATCHLIST_NAME = 'Watchlist';
